/* Life is Beautiful – lightweight scroll-snap slider for lib-* sections. */
(function () {
  function setTop() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) document.documentElement.style.setProperty('--lib-top', Math.max(0, main.getBoundingClientRect().top + window.scrollY) + 'px');
    // Height of the header parts that stay pinned while scrolling, so later banners fit below them.
    var sticky = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') sticky += el.getBoundingClientRect().height;
    });
    document.documentElement.style.setProperty('--lib-sticky', sticky + 'px');
    // A full-screen banner that starts within the first screen fills exactly the space below everything above it.
    document.querySelectorAll('.lib-full').forEach(function (el) {
      el.classList.remove('lib-full--top');
      var top = el.getBoundingClientRect().top + window.scrollY;
      if (top > 0 && top < window.innerHeight * 0.6) {
        el.style.setProperty('--lib-full-h', Math.max(300, window.innerHeight - top) + 'px');
        el.classList.add('lib-full--top');
      }
    });
  }
  var lastWidth = window.innerWidth;
  setTop();
  document.addEventListener('DOMContentLoaded', setTop);
  window.addEventListener('load', setTop);
  // Phones fire resize when the address bar hides; only re-measure when the width really changes.
  window.addEventListener('resize', function () {
    if (window.innerWidth !== lastWidth) { lastWidth = window.innerWidth; setTop(); }
  });

  function pad(x) { return (x < 10 ? '0' : '') + x; }

  function init(root) {
    if (root.dataset.libReady) return;
    var track = root.querySelector('[data-lib-track]');
    if (!track) return;
    root.dataset.libReady = '1';
    var prev = root.querySelector('[data-lib-prev]');
    var next = root.querySelector('[data-lib-next]');
    var counter = root.querySelector('[data-lib-counter]');
    var loop = root.hasAttribute('data-loop');

    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth || 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function visible() { return Math.max(1, Math.round((track.clientWidth + 1) / step())); }
    function index() { return Math.round(track.scrollLeft / step()); }

    function update() {
      var n = track.children.length, v = visible(), i = index();
      if (counter) counter.textContent = v > 1 ? (i + 1) + '–' + Math.min(n, i + v) + ' of ' + n : pad(i + 1) + ' / ' + pad(n);
      if (!loop) {
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i + v >= n;
      }
    }

    function go(dir) {
      var n = track.children.length, v = visible(), i = index() + dir;
      if (loop) { if (i < 0) i = n - v; if (i > n - v) i = 0; }
      else { i = Math.max(0, Math.min(n - v, i)); }
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () { go(1); }, delay);
      var stop = function () { clearInterval(timer); };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('touchstart', stop, { passive: true });
      root.addEventListener('focusin', stop);
    }
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-lib-slider]').forEach(init); }
  initAll();
  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
